module.exports = __webpack_public_path__ + "startpage-746fed5a/praktikumsbericht-4df31a0cd92a38fbcc39774b7ff72f03.jpeg";